import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chat-group",
  "use": "chat-group-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chat-group\"><path d=\"M4.586 5.586A2 2 0 004 7v4a2 2 0 002 2h2v3l3-3h2a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-1.414.586z\" /><path d=\"M17 11V9h1a2 2 0 012 2v4a2 2 0 01-2 2h-2v3l-3-3h-2a1.99 1.99 0 01-.938-.233L11.828 15H13a4 4 0 004-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol